import { buildSchedulePdf, type SchedulePdfInput } from './schedulePdf';
import { loadImageDataUrl } from './dailyLogPdf';

/** Build the PMS Schedule PDF and share it (mobile) or download it (desktop). */
export async function shareSchedulePdf(
  input: Omit<SchedulePdfInput, 'logoDataUrl'>,
  fileNameDateRange: string,
): Promise<'shared' | 'downloaded'> {
  const logoDataUrl = await loadImageDataUrl('/logo.png');
  const blob = await buildSchedulePdf({ ...input, logoDataUrl });

  const fileName = `PMS-Schedule_${fileNameDateRange}.pdf`;
  const file = new File([blob], fileName, { type: 'application/pdf' });
  const nav = navigator as Navigator & { canShare?: (d: ShareData) => boolean };

  if (nav.canShare && nav.canShare({ files: [file] })) {
    await nav.share({ files: [file], title: 'PMS Schedule' });
    return 'shared';
  }
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url; a.download = fileName; a.click();
  setTimeout(() => URL.revokeObjectURL(url), 4000);
  return 'downloaded';
}
